<template>
  <card-item card="item_group_customer" :tabs="tabs" :activeTab="activeTab" :id="id"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>